import { render, staticRenderFns } from "./UploadFileToOpdracht.vue?vue&type=template&id=20a590f8&scoped=true&"
import script from "./UploadFileToOpdracht.vue?vue&type=script&lang=js&"
export * from "./UploadFileToOpdracht.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileToOpdracht.vue?vue&type=style&index=0&id=20a590f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a590f8",
  null
  
)

export default component.exports